var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"fce3b543665b05116bbbc5fbb85b908a078be5e1"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["kikushiru@inditidual"]={id:"fce3b543665b05116bbbc5fbb85b908a078be5e1"};
      